const MainHeader = {
  textStyle: {
    textAlign: 'center',

    fontSize: '16px',
    fontWeight: 'bold',
    color: '#707070',
  },
};

export default MainHeader;
